import { Stack, Text } from '@repletoryreach/sdk-ui';
import { useT } from '../../../i18n/I18nProvider';
import { SWATCHES } from '../lib/data';

/** A row of swatches for a service's or a person's colour on the calendar. */
export function ColourPicker({ value, onChange, disabled, label }: {
  value: string | null;
  onChange: (c: string) => void;
  disabled?: boolean;
  label: string;
}) {
  const t = useT();
  return (
    <Stack gap="xs">
      <Text role="inputLabel">{label}</Text>
      <div className="rr-bookings__swatches" role="radiogroup" aria-label={label}>
        {SWATCHES.map((c, i) => (
          <button
            key={c}
            type="button"
            role="radio"
            aria-checked={value === c}
            aria-label={t('bookings.colour.option', { n: i + 1 })}
            disabled={disabled}
            className={`rr-bookings__swatch-btn${value === c ? ' is-active' : ''}`}
            style={{ background: c }}
            onClick={() => onChange(c)}
          />
        ))}
      </div>
    </Stack>
  );
}
